<template>
    <div id="payment">
        <SfHeading
                :level="3"
                :title="$t('Your order')"
                class="sf-heading--left sf-heading--no-underline"
        />
        <transition v-if="client" mode="out-in" name="sf-fade">
            <div class="client-informations">
                <div class="client-fly">
                    <SfHeading :level="2" :title="$t('Recipient')"></SfHeading>
                    <div class="client-flyInformation">
                        <SfIcon :icon="icons.passager.path" :viewBox="icons.passager.viewBox" size="42px"></SfIcon>
                        <div class="client-information">
                            <div class="name"><span class="client-name">{{ client.gender }} {{
                                client.lastName
                                }} {{ client.firstName }}</span>
                            </div>
                            <div class="date">
                                <span class="client-date">{{ $d(new Date(client.fly.date * 1000), 'short') }}</span>
                            </div>
                            <div class="fly">
                                <span class="client-fly-departure">{{ client.fly.departure }}</span>
                                <SfIcon :icon="icons.destinationArrow.path" :viewBox="icons.destinationArrow.viewBox"
                                        size="24px"></SfIcon>
                                <span class="client-fly-arrival">{{ client.fly.arrival }}</span>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="client-address">
                    <SfHeading :level="2" :title="$t('Delivery address')"></SfHeading>
                    <UserAddress :address="client.address"></UserAddress>
                </div>
            </div>
        </transition>

        <OrkLoader v-if="shippingAddress" :loading="loadingShipment">
            <transition>
                <div class="shipping__content">
                    <SfHeading
                            :level=2
                            :title="$t('Delivery options')"
                            class=" sf-heading--no-underline title"
                    />

                    <UserShipmentOptions v-if="shipmentMethods && shipmentMethods.length>0"
                                         :selectedMethods="selectedMethods"
                                         :shipmentMethods="shipmentMethods"
                                         @submitSelectedShipmentMethod="setShipmentMethods"
                    />
                    <div v-else class="shipping_content">
                        <SfNotification :message="$t('no shipping method found for this address')" :persistent="true"
                                        :visible="true"
                                        class="noshipping"></SfNotification>
                    </div>
                </div>

            </transition>
        </OrkLoader>
         <transition mode="out-in" name="sf-fade">
             <div class="giftCart">
                 <SfHeading
                         :level=2
                         :title="$t('Add a message')"
                         class=" sf-heading--no-underline title"
                 />
                 <div class="giftCart-wrapper">
                     <div class="giftCart-content">
                         <SfImage class="giftCart-content-image" width="290" alt="carte cadeau"
                                  src="/assets/images/For-You.gif"></SfImage>
                         <div class="giftCart-content-form">
                             <SfRadio
                                     :label="$t('Default message')"
                                     :selected="personalized"
                                     value="false"
                                     :description="$t('A default message will be sent to the customer')"
                                     class="sf-radio--transparent giftCart-content-form-radio"
                                     @change="changePersonalizedValue('false')"></SfRadio>
                             <SfRadio
                                     :label="$t('Custom message')"
                                     :selected="personalized"
                                     value="true"
                                     :description="$t('You have the possibility to write a personalized message to the customer')"
                                     class="sf-radio--transparent giftCart-content-form-radio"
                                     @change="changePersonalizedValue('true')"></SfRadio>
                             <div class="message" v-if="personalized==='true'">
                                 <transition name="fade">
                                     <SfTextarea v-model="customMessage" :label="$t('Your message')"
                                                 class="giftCart-content-form-textarea"
                                                 minlength="10"
                                                 :error-message="$t('Please type minimum 10 characters and maximum 200')"
                                                 required
                                                 @blur="customMessageBlur = false"
                                                 :valid="customMessageBlur || validCustomMessage(customMessage)"
                                                 :placeholder="$t('Write your personalized message')"
                                                 maxlength="200"></SfTextarea>
                                 </transition>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </transition>
        <SfNotification
                :icon="{icon: icons.info.path, viewBox: icons.info.viewBox}"
                :message="error.message"
                :persistent="true"
                :type="error.type"
                :visible="error.isVisible"
                class="notification"
                @click:close="error.isVisible = false"
        >
            <template #icon>
                <SfIcon :icon="icons.info.path" :view-box="icons.info.viewBox" class="icon" color="white"/>
            </template>
        </SfNotification>
        <div class="checkout actions">
            <SfButton
                    class='sf-button color-white'
                    type='button'
                    @click="goBack()"
            >
                {{ $t('Edit my shopping cart') }}
            </SfButton>
            <SfButton
                    :disabled="loading || !isDone || !isDoneShipment  "
                    aria-disabled="true"
                    class='sf-button color-secondary'
                    @click="processOrder"
            >
        <span v-if="loading">
        <SfLoader :class="{ loader: loading }" :loading="loading"></SfLoader>
            {{ $t('Loading') }}
        </span>
                <span v-else>
        {{ $t('Validate my order') }}
        </span>
            </SfButton>
        </div>


    </div>
</template>

<script>
import {
    SfHeading,
    SfButton,
    SfIcon,
    SfLoader,
    SfImage,
    SfRadio,
    SfTextarea,
    SfNotification
} from '@storefront-ui/vue';
import OrkLoader from "@/components/Ork/OrkLoader";
import UserShipmentOptions from "@/components/Checkout/UserShipmentOptions";
import UserAddress from '@/components/UserAddress.vue';


import Api from "@/api/Api";
import icons from "@/utils/icons";

import {Client} from "@/models/client";
import {ShipmentMethods} from "@/models/shipment";

export default {
    name: 'PaymentEmpowerment',

    components: {
        SfNotification,
        UserAddress,
        SfTextarea,
        UserShipmentOptions,
        OrkLoader,
        SfLoader,
        SfHeading,
        SfButton,
        SfImage,
        SfRadio,
        SfIcon
    },
    data() {
        return {
            loadingShipment: false,
            loadingAddress: false,
            shippingAddress: null,
            shipmentMethods: null,
            selectedAddress: null,
            selectedMethods: [],
            terms: false,
            isDone: false,
            paymentReady: false,
            giftCard: null,
            ip: null,
            icons: icons,
            loading: false,
            error: {message: null, type: null, isVisible: false},
            billingAddress: null,
            customMessage: null,
            customMessageBlur: true,
            personalized: "false",
            valid: false,
            isDoneShipment: false
        };
    },
    computed: {
        client: {
            get() {
                try {
                    return Client.of(JSON.parse(sessionStorage.getItem('empowermentClient')));
                } catch (e) {
                    console.log("error", e)
                    return null
                }
            }
        },
        customer: {
            get() {
                return this.$store.getters.getProfile;
            },
            set() {
            }
        },
        currentCart: {
            get() {
                return this.$store.getters.getCart;
            },
            set(cart) {
                return cart
            }
        }
    },
    watch: {
        currentCart(newCart) {
            if (newCart) {
                this.checkTotalPriceCart()
            }
        },
        client(newClient) {
            if (newClient.address) {
                this.setShippingAddress(newClient.address);
            }
        },
    },
    mounted() {
        this.isDoneShipping = false;
        this.isDone = false;
        this.changePersonalizedValue(this.personalized)
        if (this.client && this.client.address)
            this.setShippingAddress(this.client.address)
    },

    methods: {
        changePersonalizedValue(value) {
            if (value === 'true') {
                this.isDone = false;
            } else {
                this.error.isVisible = false;
                this.customMessage = null;
                this.customMessageBlur = true;
                this.isDone = true;
            }
            this.personalized = value
        },
        checkTotalPriceCart() {
            if ((this.currentCart.totalPrice.taxIncluded - this.currentCart.shippingPrice.taxIncluded) > 41.2) {
                this.error.message = this.$i18n.t('errors.empowerment.totalPrice');
                this.error.type = "danger"
                this.error.isVisible = true
            } else {
                this.error.isVisible = false
            }
        },
        goBack() {
            this.$router.push(this.$localizePath('/mon-panier')).catch();
        },

        setShipmentMethods(selectedMethodId) {
            this.selectedMethods = [selectedMethodId];
            this.isDoneShipment = false;
            this.loading = true;
            Api.cart.setShipmentMethods(this.selectedMethods)
                .then((data) => {
                    this.$store.dispatch("setCart", data);
                    this.checkTotalPriceCart()
                    this.isDoneShipment = true;
                })
                .catch((e) => {
                    let error = null;
                    switch (e.status) {
                        case 401:
                            error = this.$i18n.t("errors.shipmentMethod.unauthorized");
                            break;
                        case 409:
                            error = this.$i18n.t("errors.shipmentMethod.allReadyExist");
                            break;
                        case 404:
                            error = this.$i18n.t("errors.shipmentMethod.notFound");
                            break;
                        case 500:
                            error = this.$i18n.t("errors.server.access");
                            break;

                    }
                    this.isDoneShipment = false;
                    if (error) {
                        this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
                    }
                }).finally(() => {
                this.loading = false;

            });

        },
        setShippingAddress(address, refreshShipmentMethods = true) {
            this.selectedAddress = address ? address.name : undefined;
            return Api.cart.setShippingAddress(address)
                .then((data) => {
                    this.$store.dispatch("setCart", data);
                    this.currentCart = data;
                    this.shippingAddress = address;
                    if (refreshShipmentMethods) {
                        this.getShipmentMethods();
                    }
                })
                .catch((e) => {
                    console.error(e);
                    let error = null;
                    switch (e.status) {
                        case 401:
                            error = this.$i18n.t("errors.cartAdresse.unauthorized");
                            break;
                        case 409:
                            error = this.$i18n.t("errors.cartAdresse.allReadyExist");
                            break;
                        case 404:
                            error = this.$i18n.t("errors.cartAdresse.notFound");
                            break;
                        case 500:
                            error = this.$i18n.t("errors.server.access");
                            break;
                    }
                    if (error) {
                        this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
                    }
                })
                .finally(() => {
                    this.loadingAddress = false;
                });
        },
        getShipmentMethods() {
            this.loadingShipment = true;

            Api.cart.getShipmentMethods()
                .then((data) => {
                    this.shipmentMethods = [];
                    if (data.length > 0) {
                        for (const ShipmentMethod of data[0]) {
                            this.shipmentMethods.push(ShipmentMethods.of(ShipmentMethod));
                        }

                        this.shipmentMethods.sort((a, b) => {
                            return a.price.taxIncluded > b.price.taxIncluded ? 1 : -1;
                        });

                        this.loadingShipment = false;
                        if (this.selectedMethods && this.selectedMethods.length > 0) {
                            const selectedMethodObj = this.shipmentMethods.find(method => this.selectedMethods.includes(method.id));

                            if (selectedMethodObj) {
                                this.setShipmentMethods(selectedMethodObj.id);
                            } else {

                                this.selectedMethods = [];

                                this.$emit("isDoneShipping", false);
                                if (this.shipmentMethods && this.shipmentMethods.length === 1) {
                                    this.setShipmentMethods(this.shipmentMethods[0].id);
                                }
                            }
                        } else {

                            if (this.shipmentMethods && this.shipmentMethods.length === 1) {
                                this.setShipmentMethods(this.shipmentMethods[0].id);
                            }
                        }
                    } else {
                        this.$store.dispatch("sendNotification", {
                            type: "danger",
                            message: this.$i18n.t("errors.noshipment"),
                            icon: icons.error,
                        });
                    }
                })
                .catch((e) => {
                    this.shipmentMethods = [];
                    this.selectedMethods = [];
                    this.$emit("isDoneShipping", false);
                    this.loadingShipment = false;
                })
                .finally(() => {
                    this.loadingShipment = false;
                });
        },

        validCustomMessage(message) {
            if (this.personalized === "true") {
                if (!!message && message.length > 10 && message.length <= 200) {
                    this.error.isVisible = false
                    this.isDone = true
                    return true;
                } else {
                    this.error.message = this.$i18n.t('errors.empowerment.customMessage');
                    this.error.type = "danger"
                    this.error.isVisible = true
                    this.isDone = false
                    return false
                }
            } else {
                this.error.isVisible = false
                this.isDone = true
                return true;
            }
        },


        processOrder() {
            this.loading = true;
            let result = null;
            Api.order.AddEmpowermentCard(this.currentCart.id, this.customMessage).then((data) => {
                Api.order.validEmpowerment(this.currentCart.id)
                    .then((data) => {
                        result = data
                        sessionStorage.removeItem("empowerment")
                        sessionStorage.removeItem("empowermentClient")
                        if (result.resultCode.toLowerCase() === "authorized") {
                            window.location.replace(result.feedbackUrl + 'success?form_id=' + result.merchantReference);
                        } else {
                            window.location.replace(result.feedbackUrl + 'failure?form_id=' + result.merchantReference);
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        let error = '';
                        error = e.message;
                        const offers = [];
                        const offersId = [];
                        if (e.status) {
                            switch (e.status) {
                                case 400:
                                    if (e.message && e.message.split("'")) {
                                        offersId.push(e.message.split("'")[1]);
                                        offersId.forEach((id) => {
                                            this.currentCart.cartItems.map((item) => {
                                                if (item.product.offer.id === id) {
                                                    offers.push(item);
                                                    item.noStock = true;
                                                }
                                            });
                                        });
                                        sessionStorage.setItem('NoStockItems', JSON.stringify(offersId));
                                    }
                                    if (offers.length > 0) {
                                        this.$store.dispatch('toggleNoStockActionModal', {
                                            open: true,
                                            products: offers
                                        })
                                    } else if (e.message && e.message.endsWith('41.2')) {
                                        error = this.$i18n.t('errors.empowerment.totalPrice');
                                        this.error.message = this.$i18n.t('errors.empowerment.totalPrice');
                                        this.error.type = "danger"
                                        this.error.isVisible = true
                                    } else {
                                        this.error.message = this.$i18n.t("errors.server.access");
                                    }
                                    break;
                                case 404:
                                    error = this.$i18n.t("moneyPotNotFound");
                                    break;

                                case 422:
                                    error = this.$i18n.t("pncError");
                                    break;
                                default:
                                    error = this.$i18n.t('errors.server.access')
                                    break;
                            }

                            if (e.errorInfo && e.errorInfo.message) {
                                error = e.errorInfo.message
                                this.error.type = "danger"
                                this.error.isVisible = true
                                this.error.message = e.errorInfo.message
                            } else {
                                this.error.type = "danger"
                                this.error.isVisible = true
                                this.error.message = this.$i18n.t('errors.empowerment.default')
                                error = this.$i18n.t('errors.empowerment.default')
                            }
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: error,
                                icon: icons.error
                            });
                            this.loading = false;
                        }

                    })
            })
                .catch((e) => {
                    console.log(e)

                    let error = '';
                    error = e.message;
                    const offers = [];
                    const offersId = [];
                    if (e.status) {
                        switch (e.status) {
                            case 400:
                                if (e.message && e.message.split("'")) {
                                    offersId.push(e.message.split("'")[1]);
                                    offersId.forEach((id) => {
                                        this.currentCart.cartItems.map((item) => {
                                            if (item.product.offer.id === id) {
                                                offers.push(item);
                                                item.noStock = true;
                                            }
                                        });
                                    });
                                    sessionStorage.setItem('NoStockItems', JSON.stringify(offersId));
                                }
                                if (offers.length > 0) {
                                    this.$store.dispatch('toggleNoStockActionModal', {open: true, products: offers})
                                } else if (e.message.startsWith('Custom card message is too long')) {
                                    error = this.$i18n.t('customMessage');
                                    this.error.message = this.$i18n.t('customMessage');
                                    this.error.type = "danger";
                                    this.error.isVisible = true;
                                } else if (e.message && e.message.endsWith('41.2')) {
                                    error = this.$i18n.t('errors.empowerment.totalPrice');
                                    this.error.message = this.$i18n.t('errors.empowerment.totalPrice');
                                    this.error.type = "danger"
                                    this.error.isVisible = true
                                } else {
                                    this.error.message = this.$i18n.t("errors.server.access");
                                }
                                break;
                            case 404:
                                error = this.$i18n.t("moneyPotNotFound");
                                break;

                            case 422:
                                error = this.$i18n.t("pncError");
                                break;
                            default:
                                error = this.$i18n.t('errors.server.access')
                                break;
                        }

                        if (e.errorInfo && e.errorInfo.message) {
                            error = e.errorInfo.message
                            this.error.type = "danger"
                            this.error.isVisible = true
                            this.error.message = e.errorInfo.message
                        } else {
                            this.error.type = "danger"
                            this.error.isVisible = true
                            this.error.message = this.$i18n.t('errors.empowerment.default')
                            error = this.$i18n.t('errors.empowerment.default')
                        }
                        this.$store.dispatch('sendNotification', {
                            type: 'danger',
                            message: error,
                            icon: icons.error
                        });
                        this.loading = false;
                    }

                })
                .finally(() => {
                    this.loading = false;
                })

        },
    }
};
</script>

<style lang="scss" scoped>
.giftCart {
  &-wrapper {
    background: var(--c-primary) url(/assets/images/fd_coupon.webp) no-repeat center;
    background-size: cover;
    color: #fff;
    border-radius: 4px;
    margin: var(--spacer-base) 0;
  }

  &-content {
    display: flex;
    align-items: start;

    &-form {
      margin: var(--spacer-base) 0;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacer-sm);
      width: 100%;

      .message {
        width: 100%;
        margin: var(--spacer-sm) var(--spacer-lg) 0 var(--spacer-base);
      }

      ::v-deep {
        .sf-textarea {
          width: 100%;
          margin-bottom: 0;
          margin-top: 0;
          padding-top: var(--spacer-sm);

          &__label, &__error-message {
            color: #fff;
          }

          &__label {
            top: 0;
          }

          &__error-message {
            font-weight: bold;
          }

          textarea {
            height: 120px;
            border: none;
            border-radius: 4px;

            &:focus ~ * {
              --textarea-label-font-size: var(--font-size--base)
            }
          }
        }

        .sf-radio {
          width: 100%;

          .sf-radio__label, .sf-radio__description {
            color: #fff;
          }

          &:hover {
            .sf-radio__checkmark {
              border-color: #fff;
            }
          }

          &.is-active {
            .sf-radio__checkmark {
              border-color: #fff;
            }
          }
        }
      }
    }

    &-image {
      margin-bottom: auto;
      @include for-mobile {
        display: none;
      }
    }
  }
}

.checkout.actions {
  margin: auto 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;

  .sf-button {
    width: fit-content;
    white-space: nowrap;
    min-height: 32px;
    padding: var(--spacer-sm) var(--spacer-sm);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      width: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) 0;
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}

.coupon {
  display: flex;
  flex-wrap: wrap;
  background: var(--c-primary) url(/assets/images/fd_coupon.webp) no-repeat center;
  background-size: cover;
  color: var(--c-white);
  padding: var(--spacer-sm);
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  margin: var(--spacer-lg) 0 var(--spacer-base);

  &-label {
    display: block;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 700;
    //text-transform: uppercase;

    .title {
      display: flex;
      width: 100%;
    }

    .text {
      align-items: center;
      width: 100%;
      display: flex;
      min-height: 42px;
      line-height: 42px;
      margin-left: var(--spacer-xs);
    }

    .desc {
      font-size: var(--font-size--base);
      font-weight: 400;
      text-transform: none;
      margin-left: var(--spacer-xs);
    }
  }

  .content {
    display: flex;

    > * {
      flex: 0 0 1;
    }

    .desc {
      width: 50%;
    }
  }

  &-form {
    flex: 1;
    position: relative;
    padding: 0;
    margin: 0;

    .sf-button {
      position: absolute;
      right: 0;
      top: 0;
      width: 42px;
      height: 42px;
      // text-transform: uppercase;
    }
  }

  ::v-deep {
    .sf-input {
      margin-bottom: 0;

      &__wrapper {
        margin: var(--input-margin, 0 0 0 0);
      }

      &__error-message {
        display: none;
      }
    }
  }
}

.client-informations {
  margin: var(--spacer-xl) 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacer-xl);
  align-self: stretch;
}

.client-fly, .client-address {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;

  .sf-heading {
    margin-bottom: var(--spacer-base);
  }
}

.user-address:hover {
  border: 1px solid var(--_c-primary-background);
  box-shadow: 0 2px 5px -2px rgb(0 0 0 / 0%);
}

.client-flyInformation {
  align-self: stretch;
  padding: var(--spacer-base);
  display: flex;
  flex: 1;
  align-items: center;
  border: 1px solid var(--_c-primary-background);
  box-shadow: 0 2px 5px -2px rgb(0 0 0 / 0%);

  .client-information {
    margin-left: var(--spacer-base);
    flex: 1;

    .name {
      font-size: var(--font-size--lg);
      font-weight: bold;
      margin-bottom: var(--spacer-sm);
    }

    .fly {
      display: flex;
      align-items: center;

      .sf-icon {
        margin: 0 var(--spacer-sm);
      }
    }
  }
}
</style>
